import { PropsWithChildren } from 'react';

import { HttpContext } from './http-context';
import { useHttpProvider } from './useHttpProvider';

export function HttpProvider(props: PropsWithChildren) {
  const values = useHttpProvider();
  if (!values.httpIsReady) return <></>;
  return <HttpContext.Provider value={values}>{props.children}</HttpContext.Provider>;
}
